import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { SnackbarProvider } from '@/ui'
import { ErrorBoundary } from './components/ErrorBoundary.js'
import { App } from './App.js'
import './i18n/index.js'
import './index.css'

/**
 * QueryClient with conservative defaults:
 * - retry once on network failure, but not on application errors
 * - don't refetch when the window regains focus
 * - cache for 30s before considered stale
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30 * 1000,
    },
  },
})

const root = document.getElementById('root')
if (!root) throw new Error('Root element not found')

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <SnackbarProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </SnackbarProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
)
